(function($) {

    // Variables
    var menuOpened = false;
    var navHeight = $(".navigation").outerHeight();
    var navTopHeight = $(".navigation__top").outerHeight();
    var infoHeight = 0;
    var fullHeight = navHeight;
    if ($(".navigation-info").length) {
        infoHeight = $(".navigation-info").height();
        fullHeight = fullHeight + infoHeight;
    }

    // Set variables for css on load and resize
    document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
    document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
    document.documentElement.style.setProperty('--menu-top-height', `${navTopHeight}px`);
    var w = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == w) return;
        w = $(window).width();
        navHeight = $(".navigation").outerHeight();
        infoHeight = $(".navigation-info").height();
        navTopHeight = $(".navigation__top").outerHeight();
        fullHeight = navHeight;
        if (infoHeight){
            fullHeight = fullHeight + infoHeight;
        }
        document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
        document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
        document.documentElement.style.setProperty('--menu-top-height', `${navTopHeight}px`);
    });


    // Hamburger click
    $(".navigation__hamburger").not('.navigation__search-close').on("click", function () {
        menuOpened = !menuOpened;
        if(menuOpened){
            $(".navigation__content").addClass("navigation__content--active");
            $('html').addClass('mobile-menu_overflow');
        } else {
            $(".navigation__content").removeClass("navigation__content--active");
            $('html').removeClass('mobile-menu_overflow');
        }
        $(".navigation__hamburger-icon").toggleClass("navigation__hamburger-icon--opened");
    })






    //hover in main menu item and open dropdown
    $('.overlay').hide();
    $('.navigation__items-row').prev().each(function (){
        $(this).on("mouseenter", function() {
            $('.navigation__items-row').parent().removeClass('header__menu_item-open');
            $(this).parent().addClass('header__menu_item-open');
            $(this).closest('.navigation__content').addClass('navigation__content-hovered');
            $('.navigation-header').addClass('navigation-bg');
            $('.navigation-header').css('z-index', '100');
            $('.overlay').fadeIn(300);
        });
    })

    $('.navigation__items > .header__menu_item').each(function (){
        $(this).on("mouseenter", function() {
            $('.header__menu_item').removeClass('navigation__items-active');
            $(this).addClass('navigation__items-active');
        });
    })
    //hover out main menu item and close dropdown
    // $('.navigation__content').on("mouseleave", function() {
    //     $('.navigation__items-row').parent().removeClass('header__menu_item-open');
    //     $(this).removeClass('navigation__content-hovered');
    //     $('.navigation-header').removeClass('navigation-bg');
    //     $('.overlay').fadeOut(300);
    // });
    //hover out main menu item and close dropdown
    $('.navigation__content').on("mouseleave", function() {
        $('.navigation__items-row').parent().removeClass('header__menu_item-open');
        $('.menu-item-has-children').removeClass('navigation__items-active');
        $('.navigation__content').removeClass('navigation__content-hovered');
        $('.overlay').fadeOut(300);
    });
    //hover out main menu item and close dropdown
    $('.navigation').on("mouseleave", function() {
        $('.navigation-header').css('z-index', '');
        if (!$(this).hasClass('scrolled')){
            $('.navigation-header').removeClass('navigation-bg');
        }
    });
    //hover out main menu item and close dropdown
    $('.navigation__items > .header__menu_item:not(.menu-item-has-children)').on("mouseenter", function() {
        $('.navigation__items-row').parent().removeClass('header__menu_item-open');
        $('.navigation__content').removeClass('navigation__content-hovered');
        $('.overlay').fadeOut(300);
    });



    $(".navigation__hamburger").not('.navigation__search-close').on("click", function (ev) {
        $(".navigation").toggleClass("opened");
    })

    $(".nav__content").on("transitionend", function () {
        if(!menuOpened){
            $(".nav__container").removeClass("nav--black-bg");
        }
    })

    $(".nav__content").on("transitionend", function () {
        if(!menuOpened){
            $(".nav__container").removeClass("nav--black-bg");
        }
    })

    $(".nav__link").on("click", function () {
        if($(".navigation").hasClass("opened")){
            $(".navigation").removeClass("opened");
        }
    })

    $(".menu-item-has-children").on("click", function (e) {
        $(this).children(".navigation__submenu").addClass("sub-menu--opened");
        $(this).addClass("menu-item--opened");
    })
    $(".sub-menu__hide").click("click", function (e) {
        e.stopPropagation();
        $(this).parent(".navigation__submenu").removeClass("sub-menu--opened");
        $(this).closest('.header__menu_item').removeClass("menu-item--opened");
    })

    $('.navigation__items-col ').each(function(){
        $(this).children('.navigation__submenu_links ').hide();
        // $(this).css('max-height', 0)
        $(this).parent().on("click", function (e) {
            e.stopPropagation();
            // console.log('cisdf');
            // $(this).children('.navigation__items-col').css('max-height', $colHeight)
            $(this).children('.navigation__items-col').children('.navigation__submenu_links').slideToggle();
            $(this).toggleClass('menu-item--toggle');
            // $(this).parent(".navigation__submenu").removeClass("sub-menu--opened");
            // $(this).closest('.header__menu_item').removeClass("menu-item--opened");
        })
    });


    const nav = $(".nav__mobile-header");
    $(window).scroll( function () {
        if(window.pageYOffset > 0){
            nav.addClass("nav__mobile-header--background")
        } else {
            nav.removeClass("nav__mobile-header--background")
        }
    })

    $(window).on('load resize', function(){
    })
    let $navHeight = $('.navigation').height();
    // let $navInfoHeight = $('.navigation-info').height();
    let $navInfoHeight = $('.navigation-info').length ? $('.navigation-info').height() : 0;
    let $navFullHeight = $navHeight + $navInfoHeight;

    $(window).scroll(function(e) {
        e.preventDefault();
        if ($(window).scrollTop() > $navFullHeight || $(window).scrollTop() > $navFullHeight && $('body').hasClass('sidebar-cart-opened')) {
            $('.navigation').addClass("scrolled");
            $('.navigation').removeClass("navigation-top");
            $('.navigation--relative').css("padding-top", $navHeight);
            $('.navigation').addClass("scrollUpFixed");
            $('.navigation-header').addClass('navigation-bg');
            // $('.navigation-placeholder').css('padding-top', $navHeight);
            setTimeout(function() {
                $('.navigation').addClass("scrolled-anim");
            }, 300);
        } else {
            $('.navigation').removeClass("scrolled");
            // $('.navigation').addClass("navigation-top");
            $('.navigation-header').removeClass('navigation-bg');
            // $('.navigation-placeholder').css('padding-top', '');
            $('.navigation').removeClass("scrolled-anim");
        }


        if ($(window).scrollTop() <= $navInfoHeight || $(window).scrollTop() <= $navInfoHeight && $('body').hasClass('sidebar-cart-opened')) {
            $('.navigation--relative').css("padding-top", '');
            $('.navigation').addClass("navigation-top");
            $('.navigation').removeClass("scrollUpFixed");
        }
    });

    // Script
    let lastScroll = 0;
    $(window).on('scroll',function() {
        var scroll = $(window).scrollTop();
        if(lastScroll - scroll > 0 && scroll > $navInfoHeight) {
            $(".navigation").addClass("scrollUp ");
        } else {
            $(".navigation").removeClass("scrollUp");
        }
        lastScroll = scroll;
    });







    // Sidebar cart


    var fromTop;
    function sidebar_cart_open(){
        // Fix content
        fromTop = $(window).scrollTop();
        $(".body-content").css({
            position: "fixed",
            top: -fromTop,
            width: "100%"
        });
        if($('body').hasClass('sidebar-cart-opened')){
            sidebar_cart_close();
        }
        if (fromTop > 50) {
            $(".navigation").addClass("scrolled");
        }
        // Add body class
        $('body').addClass('sidebar-cart-opened');

    }

    function sidebar_cart_close(){
        $('body').removeClass('sidebar-cart-opened');

        $(".body-content").removeAttr("style");
        $(window).scrollTop(fromTop);
        $(".navigation.scrolled.scrollUp").css ({
            top: "0",
        });
        if ($(window).scrollTop() > 50 ) {
            $('.navigation').addClass("scrolled");
        }
    }


    function sidebar_cart_init(){

        $('.body-content, .sidebar-cart__close').click(function(e){
            if($('body').hasClass('sidebar-cart-opened')){
                sidebar_cart_close();
            }
        });


    }


    $('body').on('click','.header__icon_cart, .open-cart', function(e){
        e.preventDefault();

        setTimeout( sidebar_cart_open , 1 );

    });

    $(function() {
        sidebar_cart_init();
    });

    $( document.body ).on( 'wc_fragments_refreshed', () => {
        sidebar_cart_init();
    } );


    $( document ).on( "creepy-add-to-cart-success", function() {
        sidebar_cart_init();
        sidebar_cart_open();
    });

    $( document ).on( "creepy-add-to-cart-error", function() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

        $("button.single_add_to_cart_button").attr("disabled", true)

        setTimeout(() => {
            $("button.single_add_to_cart_button").attr("disabled", false)
        }, 5000)

    });



    $(document).ready(function() {
        $(".footer__toggle").hide();
        $(".footer__menu_title_dropdown").click(function() {
            $(this).find('.footer__hamburger-icon').toggleClass('footer__hamburger-icon--opened');
            var target = $(this).parent().children(".footer__toggle");
            $(target).slideToggle();
        });
    });

})(jQuery);